import axios from 'axios'
import { Toast } from 'vant';
import router from "../router/index.js";
import md5 from 'js-md5';



const Http = {}
//小米登陆方法
import  * as miFn from "../utils/mi";
// process.env.NODE_ENV === "development"
// var env = process.env.NODE_ENV;
var host = window.location.hostname;
var hash = window.location.hash;
const CancelToken = axios.CancelToken;
const source = CancelToken.source();


const appID = 100104;
const appKey = escape("VVl43bRcruK");
// const cUserId="mrUs5poQ7Ve1XBoPxRh11yq0A6k";
// var abb=escape("appid="+appID+"|")
console.log(md5(`appid=${appID}|${appKey}`))
const sign=md5(`appid=${appID}|${appKey}`)

// 全局loading
let loading;
let loadingNum = 0;
/*
  获取cookie方法
*/
function getCookie(name) {
    var prefix = name + "="
    var start = document.cookie.indexOf(prefix)
 
    if (start == -1) {
        return null;
    }
 
    var end = document.cookie.indexOf(";", start + prefix.length)
    if (end == -1) {
        end = document.cookie.length;
    }
 
    var value = document.cookie.substring(start + prefix.length, end)
    return unescape(value);
}
function startLoading() {
    if (loadingNum == 0) {
        Toast.loading({
            message: '加载中...',
            forbidClick: true,
          });
    }
    loadingNum++;
}
function endLoading() {
    loadingNum--;
    if (loadingNum <= 0) {
        // loading.close();
    }
}
Http.install = function (Vue) {
 
    axios.defaults.baseURL = "https://a.huodong.mi.com";
    axios.defaults.withCredentials=true;//让ajax携带cookie;
    if (host == 'admin.xaoho.cn') {
        axios.defaults.baseURL = "https://a.huodong.mi.com";
    }
    if (host == 'admin.xaoho.com') {
        axios.defaults.baseURL = "https://a.huodong.mi.com";
    }
    axios.interceptors.request.use(function (config) {
        console.log(config.data);
        //miFn.isLogin()
        if(true){
            let cUserId=getCookie("cUserId");
            let mishopServiceToken=getCookie("mishopServiceToken");
            let serviceToken=getCookie("serviceToken");
            const cookie2 =`cUserId=${cUserId};mishopServiceToken=${mishopServiceToken};serviceToken=${serviceToken}`;
            console.log(cookie2);
            config.headers["Content-Type"] = "application/javascript; charset=UTF-8";
            if (cookie2!= "" && cookie2 != null && cookie2 != undefined) {
                // config.headers.cookie = cookie2;
            }   
            config.cancelToken = source.token;
        }else{
            miFn.doLogin()
        }        
        
        startLoading();
        return config;
    }, function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    });

    axios.interceptors.response.use(function (response) {
        endLoading();
        if (response.data.code && response.data.code != 0) {
            if (response.data.code == 1002) {
                source.cancel();
                // Message.warning("信息失效");
                localStorage.clear();
                router.push("/login");
                var time1 = setTimeout(function () {
                    clearTimeout(time1)
                    router.go(0)
                }, 180)

            }
            if (response.data.code == 2000) {
                // Message.warning(response.data.msg);
            }
            if (hash != '#/login' && response.data.code !== 1002) {
                // Message.warning(response.data.msg);
            }
        }
        // 对响应数据做点什么
        return response;
    }, function (error) {
        endLoading();
        // 对响应错误做点什么
        if (error && error.response) {
            switch (error.response.status) {
                case 400:
                    error.message = '错误请求'
                    break
                case 401:
                    error.message = '未授权，请重新登录'
                    break
                case 403:
                    error.message = '拒绝访问'
                    break
                case 404:
                    error.message = '请求错误,未找到该资源'
                    break
                case 405:
                    error.message = '请求方法未允许'
                    break
                case 408:
                    error.message = '请求超时'
                    break
                case 500:
                    error.message = '服务器端出错'
                    break
                case 501:
                    error.message = '网络未实现'
                    break
                case 502:
                    error.message = '网络错误'
                    break
                case 503:
                    error.message = '服务不可用'
                    break
                case 504:
                    error.message = '网络超时'
                    break
                default:
                    error.message = `连接错误${error.response.status}`
            }
        }
        // Message.warning(error.message);
        return Promise.reject(error);
    });

    Vue.prototype.$http = axios;

}
export default Http



